<template>
  <a-config-provider :locale="zhCN">
    <router-view />
  </a-config-provider>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import zhCN from '@arco-design/web-vue/es/locale/lang/zh-cn'

// Initialize auth state globally
const authStore = useAuthStore()

onMounted(() => {
  console.log('App.vue: Initializing auth state')
  authStore.initializeAuth()
})
</script>

<style>
#app {
  width: 100%;
  height: 100vh;
}
</style>